import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RegionRestrictions } from '../models/classes/region-restrictions';

@Injectable({
  providedIn: 'root',
})

export class DatavalidityService {
  ip = environment.ipServer;
  constructor(private http: HttpClient) {}

  getRestrictions(regionID,userID) {
    const userUrl = `${this.ip}/api/RegionMetaData`;
    const url = `${userUrl}/GetUserRestriction?regionID=${regionID}&userID=${userID}`;
    return this.http.get<RegionRestrictions>(url,{ observe: 'response' });
  }

  setRestrictions(restriction:RegionRestrictions){
    const userUrl = `${this.ip}/api/RegionMetaData`;
    const url = `${userUrl}/SetRegionRestriction`;
    return this.http.post(url,restriction,{ observe: 'response' });
  }
}
